const palette = {
  type: 'light',
  primary: {
    lightest: 'hsla(6, 95%, 95%, 1)',
    light: 'hsla(6, 95%, 85%, 1)',
    main: 'hsla(6, 95%, 62%, 1)',
    dark: 'hsla(6, 95%, 39%, 1)',
    hover:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FEE8E6',
    darkest: 'hsla(6, 95%, 20%, 1)',
    contrastText: '#fff',
    gradient:
      'linear-gradient(90.15deg, #FF2651 -42.76%, #FF2651 -41.32%, #FF7B2C 102.01%)',
  },
  secondary: {
    main: 'hsla(255, 8%, 40%, 1)',
  },
  error: {
    lightest: 'hsla(348, 95%, 95%, 1)',
    light: 'hsla(348, 95%, 85%, 1)',
    main: 'hsla(348, 95%, 57%, 1)',
    dark: 'hsla(348, 95%, 20%, 1)',
  },
  warning: {
    lightest: 'hsla(40, 100%, 95%, 1)',
    light: 'hsla(40, 100%, 85%, 1)',
    main: 'hsla(40, 100%, 57%, 1)',
    dark: 'hsla(40, 100%, 20%, 1)',
    gradient:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #FFF7E6;',
  },
  info: {
    lightest: 'hsla(199, 98%, 95%, 1)',
    light: 'hsla(199, 98%, 85%, 1)',
    main: 'hsla(199, 98%, 48%, 1)',
    dark: 'hsla(199, 98%, 20%, 1)',
  },
  viewAsTenant: {
    dark: 'hsla(199, 98%, 85%, 1)',
    main: '#fff',
    light: 'hsla(199, 98%, 95%, 1)',
    contrastText: 'hsla(199, 98%, 48%, 1)',
  },
  success: {
    lightest: 'hsla(122, 57%, 95%, 1)',
    light: 'hsla(122, 57%, 85%, 1)',
    main: 'hsla(120, 57%, 49%, 1)',
    dark: 'hsla(122, 57%, 20%, 1)',
  },
  accent: {
    main: '#282143',
    dark: '#433c5d',
    disabled: 'rgba(67, 60, 93, 0.25);',
  },
  text: {
    primary: '#0a0a0a',
    secondary: '#171717',
    tertiary: '#737373',
    body: 'rgba(0, 0, 0, 0.7)',
    disabled: '#a3a3a3',
    lightest: '#a3a3a3',
    lightish: '#525252',
    light: '#737373',
    main: '#171717',
    dark: '#0a0a0a',
    contrastText: '#0a0a0a',
  },
  // Used by default for card buttons, dropdown triangles, list item icons and buttons
  action: {
    active: '#6B7280',
    focus: 'rgba(55, 65, 81, 0.12)',
    hover: 'rgba(55, 65, 81, 0.04)',
    selected: 'rgba(55, 65, 81, 0.08)',
    disabledBackground: 'rgba(55, 65, 81, 0.12)',
    disabled: 'rgba(55, 65, 81, 0.26)',
    activatedOpacity: 0.12,
    disabledOpacity: 0.38,
    hoverOpacity: 0.55,
    selectedOpacity: 0.08,
  },
  common: {
    outline: 'rgba(0, 0, 0, 0.08)',
    divider: 'rgba(0, 0, 0, 0.06)',
    white: '#fff',
  },
  outline: {
    main: 'rgba(0, 0, 0, 0.08)',
    contrastText: '#000',
  },
}

export default palette
